import { getContext } from 'svelte';
import type { LiveDropInfoContextState } from '../../runes/setLiveDropInfoContext/setLiveDropInfoContext.svelte';
import { Contexts } from '#lib/constants/contexts.js';

export const getLiveDropInfoContext = () => {
	return getContext<{ liveDropInfoCtx: LiveDropInfoContextState }>(
		Contexts.LiveDropInfo
	);
};
